import { descriptors, EnvironmentNode } from "@dinahmoe/dmafjs-core";

import { visualEntities } from "../../entities.js";

class VisualEnvironmentNode extends EnvironmentNode {
  constructor(cNodeInitData) {
    const { uid, namespace, patch, props } = cNodeInitData;
    const envImplementation = resolveEnvImplementation(namespace);

    super({ uid, namespace, envImplementation, props });

    this.patch = patch;
  }
}

function resolveEnvImplementation(namespace) {
  let impl = visualEntities.get(namespace);
  if (impl) return impl;

  let desc = descriptors.get(namespace);
  while (desc?.extends) {
    impl = visualEntities.get(desc.extends);
    if (impl) return impl;
    desc = descriptors.get(desc.extends);
  }

  return undefined;
}

export { VisualEnvironmentNode };
